import { render } from "./customizeSingleSubOption.vue?vue&type=template&id=304b1958"
import script from "./customizeSingleSubOption.vue?vue&type=script&lang=js"
export * from "./customizeSingleSubOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__